import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Question } from '../../../model';

import { environment } from '../../../../';
import { CookieManagerService, ErrorManagerService, HttpClientService, AnswerSelectorPipe } from '../../../../shared';
import { AnswersStatus, ApiEndpoints } from '../../../constant';

@Component({
  selector: 'app-gp2-tp6',
  templateUrl: './gp2-tp6.component.html',
  styleUrls: ['./gp2-tp6.component.css', '../../../../css/paper-layouts.component.css']
})
export class Gp2Tp6Component implements OnInit {
  @Input() question: Question;
  @Input() type: string;

  public answerQustion = new AnswerSelectorPipe();
  public forcusClasses: Array<string> = AnswersStatus.answerClasses;
  public selectedClasses: Array<string> = AnswersStatus.answerClasses;
  public answerSelectorPipe = new AnswerSelectorPipe();
  public enable: boolean = false;

  constructor(private httpClientService: HttpClientService,
    private route: ActivatedRoute,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService) { }

  ngOnInit() {
    // this.selectedClasses = this.answerSelectorPipe.convert(false,{ 'index': parseInt(this.question.selectedAnswerIndex), 'index2': parseInt(this.question.userAnswerIndex) });
    this.getColorCode();
  }

  getColorCode() {
    let answerSelectorPipe = new AnswerSelectorPipe();
    if (this.type == ApiEndpoints.questingViewingTypeReport) {
      let getCorrecctClorCodeForReport = answerSelectorPipe.getCorrecctClorCodeForReport(this.question);
      this.selectedClasses = getCorrecctClorCodeForReport['selectedClasses'];
      this.forcusClasses = getCorrecctClorCodeForReport['forcusClasses'];
    } else {
      let getCorrecctClorCodeForExam = answerSelectorPipe.getCorrecctClorCodeForExam(this.question);
      this.selectedClasses = getCorrecctClorCodeForExam['selectedClasses'];
      this.forcusClasses = getCorrecctClorCodeForExam['forcusClasses'];
    }
  }

   enableButton(answerType): boolean {
    if (this.question.answerType == 'UNDERLINE_CIRCLE') {
      this.enable = false;
      return this.enable;
    } else {
      this.enable = true;
      return this.enable;
    }
  }

  ngOnChanges(changes) {
    if (this.question.userOptionUnderline) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = this.answerSelectorPipe.convert(false,{ 'index': parseInt(this.question.selectedAnswerIndex) });
    }
    if (this.question.userOptionCircle) {
      this.selectedClasses = AnswersStatus.answerClasses;
      this.forcusClasses = this.answerSelectorPipe.transform(false,{ 'index': parseInt(this.question.selectedAnswerIndex) });
    }
    if (!this.question.selectedAnswerid) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = AnswersStatus.answerClasses;
    }
  }

  underlineCorrectAnswer(answer, answerIndex) {
    // if (this.question.selectedAnswerIndex !== answerIndex) {
      this.forcusClasses = AnswersStatus.answerClasses;
      this.selectedClasses = this.answerQustion.convert(false,{ 'array': this.selectedClasses, 'index': answerIndex });
      this.question.selectedAnswerIndex = answerIndex;
      this.question.selectedAnswerid = answer;
      this.question.userOptionUnderline = true;
      this.question.userOptionCircle = false;
      if (!this.question.selectedAnswerid) {
        this.forcusClasses = AnswersStatus.answerClasses;
        this.selectedClasses = AnswersStatus.answerClasses;
      }
    // } else {
    //   this.selectedClasses = this.answerQustion.convert({ 'array': this.selectedClasses, 'index': undefined });
    //   this.question.selectedAnswerIndex = undefined;
    //   this.question.selectedAnswerid = undefined;
    // }
  }

  selectCorrectAnswer(answer, answerIndex) {
    // if (this.question.selectedAnswerIndex !== answerIndex) {
      this.selectedClasses = AnswersStatus.answerClasses;
      this.forcusClasses = this.answerQustion.transform(false,{ 'array': this.forcusClasses, 'index': answerIndex });
      this.question.selectedAnswerIndex = answerIndex;
      this.question.selectedAnswerid = answer;
      this.question.userOptionCircle = true;
      this.question.userOptionUnderline = false;
      if (!this.question.selectedAnswerid) {
        this.selectedClasses = AnswersStatus.answerClasses;
        this.forcusClasses = AnswersStatus.answerClasses;
      }
    // } else {
    //   this.forcusClasses = this.answerQustion.transform({ 'array': this.forcusClasses, 'index': undefined });
    //   this.question.selectedAnswerIndex = undefined;
    //   this.question.selectedAnswerid = undefined;
    // }
  }

}




// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-layouts/group/gp2-tp6/gp2-tp6.component.ts